import { initShaderProgram } from "../core/shader-utils"
import { drawScene } from "./draw-scene"
import { initBuffers } from "./init-buffers"
import vertexShader from "@/globe-scale/shader/main.vert"
import fragmentShader from "@/globe-scale/shader/main.frag"
import commonShader from "@/globe-scale/shader/common.frag"

export interface ProgramInfo {
    program: WebGLProgram
    attribLocations: {
        vertexPosition: number
    }
    uniformLocations: {
        projectionMatrix: WebGLUniformLocation | null
        modelViewMatrix: WebGLUniformLocation | null
        iTime: WebGLUniformLocation | null
        uScroll: WebGLUniformLocation | null
        uRotationAngle: WebGLUniformLocation | null
    }
}

export interface BufferGroup {
    position: WebGLBuffer | null
}

export function initializeScene(canvas: HTMLCanvasElement) {
    const gl = canvas.getContext('webgl', { antialias: true })
    if (gl === null) {
        throw new Error('Couldnt get webgl context')
    }

    // Set clear color to black, fully opaque
    gl.clearColor(0.0, 0.0, 0.0, 1.0)
    // Clear the color buffer with specified clear color
    gl.clear(gl.COLOR_BUFFER_BIT)



    // Prepend common shader helpers (noise, random, etc.) so they're available
    // to the sphere fragment shader without duplicating code.
    const combinedFragment = commonShader + "\n" + fragmentShader
    const shaderProgram = initShaderProgram(gl, vertexShader, combinedFragment)

    const programInfo: ProgramInfo = {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            iTime: gl.getUniformLocation(shaderProgram, "iTime"),
            uScroll: gl.getUniformLocation(shaderProgram, "uScroll"),
            uRotationAngle: gl.getUniformLocation(shaderProgram, "uRotationAngle"),
        },
    }

    // Here's where we call the routine that builds all the
    // objects we'll be drawing.
    const buffers = initBuffers(gl)


    // Draw the scene repeatedly
    function render(now: number) {
        now *= 0.001 // convert to seconds

        drawScene(gl!, programInfo, buffers, parseInt(Date.now().toString().substring(6)))
        // cubeRotation += deltaTime

        requestAnimationFrame(render)
    }
    requestAnimationFrame(render)
}

